// extracted by mini-css-extract-plugin
export default {"labelContainer":"label-module__labelContainer___kat_c","label":"label-module__label___ADuqQ"};